import { $ABTest, $UserAgent } from '@lemon8/web-app-shared/atom';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';

/**
 * 0: control group
 * 1: the count of KEP internal links expand from 6 to 26
 */
export const $KEPInternalLinkExpand: Atom<number> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 1;
  }
  return _get(parameters, ['seo_web', 'enable_kep_bot_traffic'], 0);
});

export const $HitKEPInternalLinkExpand: Atom<boolean> = atom((get) => {
  const internalLinkConfig = get($KEPInternalLinkExpand);
  const { isBot } = get($UserAgent);
  return isBot && internalLinkConfig === 1;
});

/**
 * 0: control group
 * 1: the maximum count of KEP comments under each article shift from 2 to 10
 */
export const $KEPCommentsExpand: Atom<number> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 1;
  }
  return _get(parameters, ['seo_web', 'enable_kep_comment_bot_traffic'], 0);
});

export const $HitKEPCommentsExpand: Atom<boolean> = atom((get) => {
  const kepCommentsConfig = get($KEPCommentsExpand);
  const { isBot } = get($UserAgent);
  return isBot && kepCommentsConfig === 1;
});
